export default __webpack_public_path__ + "static/media/arrows-expand-right.d512e1cf.svg";